import { useEffect } from 'react'

import { useGlobalStaticStateContext } from './useGlobalStaticState'

const DEFAULT_BOTTOM_MARGIN = 0
export const DISABLE_BOTTON_MARGIN = -100

// https://oss.navercorp.com/naverapp/naverapp-docs/blob/dfd5b853284bd8128e8a00c970298a0ba6f60606/docs/BrowserInterface/inapp_scheme_interface.md#floating-toolbar-위치조절
export const useMoveNaverAppTopButton = (bottomMargin: number) => {
  const { isFromNaverApp } = useGlobalStaticStateContext()

  const moveFloatingTopButton = (bottomMargin: number) => {
    location.href = `naverapp://floatingtoolbar?bottomMargin=${bottomMargin}`
    window.naverAppFloatingToolBarBottomMargin = bottomMargin
  }

  useEffect(() => {
    if (isFromNaverApp) {
      moveFloatingTopButton(bottomMargin)
    }

    return () => {
      if (isFromNaverApp) {
        moveFloatingTopButton(DEFAULT_BOTTOM_MARGIN)
      }
    }
  }, [bottomMargin, isFromNaverApp])
}

export default useMoveNaverAppTopButton
